import React, { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { apiUrl } from '#AdminPanelFrontend/services/api';

export type SsoConfig = {
	enabled: boolean;
	loginUrl: string | null;
	logoutUrl: string | null;
};

const defaultConfig: SsoConfig = {
	enabled: false,
	loginUrl: null,
	logoutUrl: null,
};

const SsoContext = createContext<SsoConfig>(defaultConfig);

export function SsoProvider({ children }: { children: ReactNode }) {
	const [config, setConfig] = useState<SsoConfig>(defaultConfig);

	useEffect(() => {
		fetch(apiUrl('/auth/sso/config'))
			.then((res) => res.json())
			.then((data: SsoConfig) => setConfig(data))
			.catch(() => setConfig(defaultConfig));
	}, []);

	return <SsoContext.Provider value={config}>{children}</SsoContext.Provider>;
}

export function useSso() {
	return useContext(SsoContext);
}
